'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Functions = require('../core/Functions');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _UIPopoverCloseButton = require('./UIPopoverCloseButton');

var _UIPopoverCloseButton2 = _interopRequireDefault(_UIPopoverCloseButton);

var _PopoverContext = require('../context/PopoverContext');

var _colors = require('HubStyleTokens/colors');

var _sizes = require('HubStyleTokens/sizes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Header = _styledComponents2.default.header.withConfig({
  displayName: 'UIPopoverHeader__Header'
})(['display:flex;justify-content:space-between;align-items:flex-start;&&{background:', ';', ';}'], function (_ref) {
  var popoverUse = _ref.popoverUse;
  return popoverUse === 'shepherd' ? _colors.THUNDERDOME : 'inherit';
}, function (_ref2) {
  var popoverUse = _ref2.popoverUse;
  return popoverUse === 'shepherd' ? (0, _styledComponents.css)(['border-top-right-radius:', ';border-top-left-radius:', ';color:', ';padding:', ' ', ';'], _sizes.BUTTON_RADIUS, _sizes.BUTTON_RADIUS, _colors.OLAF, _sizes.SHEPHERD_PADDING_Y, _sizes.POPOVER_PADDING_X) : null;
});

function UIPopoverHeader(_ref3) {
  var className = _ref3.className,
      children = _ref3.children,
      flush = _ref3.flush,
      onOpenChange = _ref3.onOpenChange,
      showCloseButton = _ref3.showCloseButton,
      popoverContext = _ref3.popoverContext,
      rest = _objectWithoutProperties(_ref3, ['className', 'children', 'flush', 'onOpenChange', 'showCloseButton', 'popoverContext']);

  return _react2.default.createElement(
    Header,
    _extends({}, rest, {
      className: (0, _classNames2.default)('uiPopoverHeader', 'private-popover__header', { 'private-popover__header--flush': flush }, className),
      popoverUse: popoverContext.use
    }),
    children,
    showCloseButton && _react2.default.createElement(_UIPopoverCloseButton2.default, {
      popoverUse: popoverContext.use,
      onClick: function onClick() {
        return (0, _Functions.callIfPossible)(onOpenChange, (0, _SyntheticEvent2.default)(false));
      }
    })
  );
}

UIPopoverHeader.propTypes = {
  children: _react.PropTypes.node,
  flush: _react.PropTypes.bool,
  showCloseButton: _react.PropTypes.bool,
  onOpenChange: _react.PropTypes.func,
  popoverContext: _PopoverContext.popoverContextPropType
};

UIPopoverHeader.displayName = 'UIPopoverHeader';

exports.default = (0, _PopoverContext.ConsumesPopoverContext)(UIPopoverHeader);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/tooltip/UIPopoverHeader.js
// module id = 457
// module chunks = 171